var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import TextField from "../TextField";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ClearIcon from "@mui/icons-material/Clear";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider, TimePicker as MuiTimePicker, } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { ClickAwayListener, Grow, List, Paper, Popper, } from "@mui/material";
import { CheckIconOption } from "../Autocomplete/components";
import { TIME_OPTIONS } from "./constants";
import ListItemButton from "../../ListItemButton";
var timeFormat = "hh:mm A";
var TimePicker = function (_a) {
    var onChange = _a.onChange, value = _a.value, format = _a.format, _b = _a.size, size = _b === void 0 ? "large" : _b, slotProps = _a.slotProps, _c = _a.defaultValue, defaultValue = _c === void 0 ? null : _c, rest = __rest(_a, ["onChange", "value", "format", "size", "slotProps", "defaultValue"]);
    var _d = __read(React.useState(defaultValue), 2), localValue = _d[0], setValue = _d[1];
    var _e = __read(React.useState(null), 2), anchorEl = _e[0], setAnchorEl = _e[1];
    var ref = React.useRef(null);
    var open = Boolean(anchorEl);
    /**
     * Cant figure out how to unit test timepicker
     * it uses javascript and click position within a div
     */
    /* istanbul ignore next */
    var handleChange = function (newValue) {
        setValue(newValue);
    };
    var changeListener = onChange || handleChange;
    /**
     * On input click, open popover via setting an anchor el
     */
    var onInputClick = function (e) {
        var _a, _b;
        if ((_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains("MuiInputBase-input")) {
            openDropdown();
        }
    };
    /**
     * open dropdown of time options
     */
    var openDropdown = function () {
        setAnchorEl(ref === null || ref === void 0 ? void 0 : ref.current);
    };
    /**
     * When popover triggers a close event, remove anchor
     */
    var onClose = function () {
        setAnchorEl(null);
    };
    /**
     * When an option is selected create a dayjs object via the selected time and its timeFormat
     * trigger a changeEvent with this new object and close popover
     */
    var selectOption = function (time) {
        changeListener(dayjs(time, timeFormat), { validationError: null });
        onClose();
    };
    /**
     * When clear is selected, trigger change event with null data
     */
    var clear = function () {
        changeListener(null, { validationError: null });
    };
    var valueToUse = value || localValue;
    return (_jsx(ClickAwayListener, __assign({ onClickAway: onClose }, { children: _jsx("div", { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx(MuiTimePicker, __assign({ format: format, inputRef: ref, value: valueToUse, onChange: changeListener, slots: {
                            textField: TextField,
                        }, slotProps: __assign(__assign({}, slotProps), { textField: __assign({ onClick: onInputClick, endAdornment: valueToUse ? _jsx(ClearIcon, {}) : _jsx(AccessTimeIcon, {}), endAdornmentClick: valueToUse ? clear : openDropdown }, slotProps === null || slotProps === void 0 ? void 0 : slotProps.textField) }) }, rest)), _jsx(Popper, __assign({ open: open, anchorEl: anchorEl, placement: "bottom-start", transition: true, sx: {
                            pt: 2.5,
                            zIndex: 1300,
                        } }, { children: function (_a) {
                            var TransitionProps = _a.TransitionProps;
                            return (_jsx(Grow, __assign({}, TransitionProps, { timeout: 200 }, { children: _jsx(Paper, __assign({ sx: {
                                        maxHeight: 360,
                                        overflowY: "auto",
                                    } }, { children: _jsx(List, __assign({ sx: { p: 2 } }, { children: TIME_OPTIONS.map(function (o) { return (_jsx(ListItemButton, __assign({ id: o, selectOption: selectOption, size: size }, { children: _jsx(CheckIconOption, { option: {
                                                    id: o,
                                                    name: o,
                                                }, state: {
                                                    selected: o === (valueToUse === null || valueToUse === void 0 ? void 0 : valueToUse.format(timeFormat)),
                                                }, size: size }) }), o)); }) })) })) })));
                        } }))] })) }) })));
};
export default TimePicker;
